import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IPerson, IReferTypePerson } from '@/Module/Auth/Model/DataModel';
import { AuthService } from '@/Module/Auth/Service';
import { CookieService } from '@/Module/Core/Service';

export const putReferTypePersonAction = createAsyncThunk<IPerson[], IReferTypePerson>(
  'Auth/putReferTypePerson',
  async (req, { signal }) => {
    const accessToken = CookieService.getAccessToken();
    return AuthService.putReferType(accessToken, req, signal).then();
  },
);
